export default "__VITE_ASSET__DyLZ1PvR__"